export default {
      id: "warning-usage",
      viewBox: "0 0 13 12",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#warning-usage",
      toString: function () {
        return this.url;
      }
    }